const BD_Variable = {
  data: [],
  set: (argData) => (BD_Variable.data = argData),

  resolveBlock: (block) => {
    if (!block) return block;

    try {
      const blockStr = JSON.stringify(block);
			var blockReplaced = blockStr

      for (let variable of BD_Variable.data) {
        const varName = "{{" + variable.name + "}}";
        blockReplaced = blockStr.replace(new RegExp(varName, "g"), variable.value);
      }

      blockReplaced = blockReplaced.replace(new RegExp('{{player_name}}', "g"), CFG.user.nickname);

      block = JSON.parse(blockReplaced);
    } catch (e) {
			// console.log("e", e);
    }

    return block;
  },

	getAudioFromVariable: (data) => {
		return BD_Variable.getMediaFromVariable('audio', data)
	},

	getVideoFromVariable: (data) => {
		return BD_Variable.getMediaFromVariable('video', data)
	},

	getMediaFromVariable: (type, data) => {
		if(!data.variable.use_variable || data.variable.from_variable_type !== type) return null

		const varName = data.variable.from_variable_name
		const varValue = BD_Variable.data.find(v => v.name === varName)
		if(!varValue || !varValue.value) return

		return varValue.value
	}
};
